export default {
    stickers: {
        title: 'klistermärken',
        stickerOpacity: 'Genomskinlighet för klistermärke',
        stickerColor: 'Klistermärkesfärg',
        shapes: {
            title: 'Former och figurer',
            rectangle: 'Rektangel',
            circle: 'Cirkel',
            triangle: 'Triangle ',
        },
        emojis: {
            title: 'Emojis ',
        },
    },
};
